import React, {useState} from 'react';
import {DEFAULT_FACEBOOK_DASHBOARD_TAB, FACEBOOK_DASHBOARD_TABS_LIST} from "../../constants/facebook-constant";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import CampaignsList from "../campaign/campaign-list";
import TargetingList from "../targeting/targeting-list";
import DesignProductsList from "../design-product/design-product-list";
import ParentProductsList from "../parent-product/parent-product-list";
import AdSetList from "../ad-set/ad-set-list";
import ThemesQuoteDashboard from "../themes-quotes/themes-quotes-dashboard";

const tabsList = FACEBOOK_DASHBOARD_TABS_LIST;

const FacebookDashboard = () => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_FACEBOOK_DASHBOARD_TAB);

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start items-center m-2 pb-2">
                        <div className="text-xl">
                            Facebook
                        </div>

                        <div className={'flex ml-4'}>
                            <ShowTabsList
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                tabsList={tabsList}/>
                        </div>
                    </div>

                    <div className="justify-start">

                        <div className="px-4">

                            {selectedTab?.key === 'facebook-campaign' &&
                                <div>
                                    <CampaignsList/>
                                </div>
                            }

                            {selectedTab?.key === 'facebook-ad-set' &&
                                <div>
                                    <AdSetList/>
                                </div>
                            }

                            {selectedTab?.key === 'facebook-targeting' &&
                                <div>
                                    <TargetingList/>
                                </div>
                            }

                            {selectedTab?.key === 'design-products' &&
                                <div>
                                    <DesignProductsList/>
                                </div>
                            }

                            {selectedTab?.key === 'parent-products' &&
                                <div>
                                    <ParentProductsList/>
                                </div>
                            }

                            {selectedTab?.key === 'themes-quotes' &&
                                <div>
                                    <ThemesQuoteDashboard/>
                                </div>
                            }

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default FacebookDashboard
